import { render, staticRenderFns } from "./SecondaryTopNavMenus.vue?vue&type=template&id=e52014d2&scoped=true"
import script from "./SecondaryTopNavMenus.vue?vue&type=script&lang=js"
export * from "./SecondaryTopNavMenus.vue?vue&type=script&lang=js"
import style0 from "./SecondaryTopNavMenus.vue?vue&type=style&index=0&id=e52014d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52014d2",
  null
  
)

export default component.exports